import React from "react";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { caseStudies } from "../mock/mock";

const CaseStudies = () => {
  const navigate = useNavigate();
  return (
    <section id="case-studies" className="section-pad grid-dots border-b-2 border-[#0A0A0A]">
      <div className="container-x">
        <div className="max-w-3xl mb-14">
          <p className="eyebrow text-neutral-500">/ Case Studies</p>
          <h2 className="mt-4 display text-4xl md:text-5xl font-extrabold uppercase leading-[0.95]">
            Real-World <span className="hl">Transformations</span>
          </h2>
          <p className="mt-5 text-neutral-700 leading-relaxed">
            How we've helped global businesses accelerate growth and efficiency through tech-driven success stories.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-7">
          {caseStudies.map((c) => (
            <div key={c.title} onClick={() => navigate(`/case-studies/${c.slug}`)} className="card-brutal group overflow-hidden flex flex-col cursor-pointer" data-cursor>
              <div className="relative h-48 overflow-hidden border-b-2 border-[#0A0A0A]">
                <img src={c.image} alt={c.title} className="w-full h-full object-cover bw" />
                <span className="absolute top-0 left-0 mono text-[11px] uppercase tracking-widest bg-[#0A0A0A] text-[#F4F1EA] px-3 py-1.5">
                  {c.tag}
                </span>
              </div>
              <div className="p-6 flex flex-col flex-1">
                <h3 className="display text-lg font-bold uppercase leading-tight mb-2">{c.title}</h3>
                <p className="text-sm text-neutral-600 leading-relaxed mb-5">{c.desc}</p>
                <div className="grid grid-cols-2 gap-4 mb-5 mt-auto">
                  {c.metrics.map((m) => (
                    <div key={m.label} className="border-2 border-[#0A0A0A] p-3">
                      <p className="display text-2xl font-extrabold">{m.value}</p>
                      <p className="mono text-[10px] uppercase tracking-wide text-neutral-500 mt-1">{m.label}</p>
                    </div>
                  ))}
                </div>
                <button className="inline-flex items-center gap-2 mono text-[12px] font-bold uppercase tracking-widest group-hover:gap-4 transition-all">
                  Read Case Study <ArrowRight size={15} />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;
